module.exports = __webpack_public_path__ + "static/media/400380_02.6df5cb43.png";